var map = {
	"./30-min.svg": "ed88",
	"./QR.svg": "f140",
	"./SBP.svg": "3474",
	"./acquire.svg": "9efb",
	"./amount-lot.svg": "c0fe",
	"./amount-low.svg": "a05d",
	"./amount-mid.svg": "d151",
	"./apple.svg": "54c6",
	"./appstore.svg": "4b42",
	"./arrow-left.svg": "9ba7",
	"./arrow-top.svg": "5e55",
	"./arrow.svg": "3c0a",
	"./bag.svg": "acf4",
	"./balance.svg": "fd0f",
	"./bmsdev/logo-desktop.svg": "dc22",
	"./bmsdev/logo-mobile.svg": "c73e",
	"./buy.svg": "fd8a",
	"./camera.svg": "eae6",
	"./cart.svg": "90e3",
	"./cash.svg": "ac5a",
	"./cashback.svg": "5dd4",
	"./check.svg": "5236",
	"./chotof/logo-desktop.svg": "f597",
	"./chotof/logo-mobile.svg": "477d",
	"./circle.svg": "bcfb",
	"./clock.svg": "4ccf",
	"./close.svg": "6282",
	"./delete.svg": "28e1",
	"./edit.svg": "8399",
	"./empty-cart.svg": "adb2",
	"./error.svg": "2804",
	"./form.svg": "174e",
	"./gift.svg": "bcab",
	"./google.svg": "905a",
	"./googleplay.svg": "aa1d",
	"./heart.svg": "a36f",
	"./hot-offer.svg": "e636",
	"./hotoff/logo-desktop.svg": "05ec",
	"./hotoff/logo-mobile.svg": "d9fa",
	"./list.svg": "dcef",
	"./logo-desktop.svg": "aeeb",
	"./logo-mobile.svg": "7caa",
	"./logo_desktop.svg": "a38c",
	"./logo_mobile.svg": "751e",
	"./logout.svg": "24fc",
	"./maestro.svg": "7cf9",
	"./mastercard.svg": "7110",
	"./message.svg": "6d6b",
	"./mir.svg": "2545",
	"./num.svg": "a302",
	"./ok.svg": "cc84",
	"./partner-start-1.svg": "4500",
	"./partner-start-2.svg": "334a",
	"./partner.svg": "be14",
	"./pay.svg": "4df1",
	"./phone.svg": "9855",
	"./product.svg": "f32d",
	"./question.svg": "9b39",
	"./sales.svg": "3802",
	"./sbp-black.svg": "49e8",
	"./sbp-white.svg": "744e",
	"./scan_me.svg": "02d9",
	"./site.svg": "0e3e",
	"./slim-arrow.svg": "281a",
	"./start-cart.svg": "e106",
	"./start-phone.svg": "c5ed",
	"./start-push.svg": "8fb9",
	"./start-sound.svg": "f78b",
	"./success-fill.svg": "df35",
	"./success.svg": "17bf",
	"./tab-all.svg": "9b42",
	"./tab-another.svg": "0b83",
	"./tab-car.svg": "d0e0",
	"./tab-food.svg": "d22b",
	"./tab-health.svg": "204c",
	"./tab-shop.svg": "2824",
	"./tab-travel.svg": "7fdc",
	"./trash.svg": "dab5",
	"./user.svg": "7393",
	"./visa.svg": "81b7",
	"./warning.svg": "248b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";